export interface CustomerApiTypeData {
  customerApiTypeId: string;
  customerApiTypeDescription: string;
}

export const defaultCustomerApiTypeData: CustomerApiTypeData = {
  customerApiTypeId: null,
  customerApiTypeDescription: null,
};
